import { Component, OnInit } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { FieldConfig } from "../../../_models/field.interface";
@Component({
    selector: "app-sliderToggle",
    template: `
        <div [formGroup]="group" [style.visibility]="!field.visible ? 'hidden' : 'visible'">
            <mat-slide-toggle [checked]="field.value" [id]="field.name" [disabled]="field.disabled"
            [ngStyle]="field.style()" (change)="field.change($event)"><label class="cs_label_toggle">{{field.label}}</label>
          </mat-slide-toggle>
        </div>
    `,
    styles: []
})
export class SliderToggleComponent implements OnInit {
    field: FieldConfig;
    group: UntypedFormGroup;

    constructor() { }
    ngOnInit() { }
}